<template>
  <el-upload
          action="#"
          accept="image/*,.pdf,.doc,.docx"
          class="upload-demo"
          multiple
          :limit="1"
          ref="upload"
          :on-exceed="handleExceed"
          :on-change="handlePreview"  :show-file-list="true"
          :file-list="fileList" :auto-upload="false">
    <el-button size="small" type="primary" v-if="!fileSerial">点击上传</el-button>
    <el-button size="small" type="primary" v-else>重新上传</el-button>
    <div slot="tip"><slot></slot></div>
  </el-upload>
</template>
<script>
import {uploadFile} from '@/api/common'
export default {
  components: {},
  props: ["fileSerial","show", "fileName"],
  data() {
    return {
        showList: false,
        fileList:[],
        fileData:null,
    }
  },
  computed: {
  },
  watch: {},
  created() {
    if(this.show){
      this.showList= this.show;
    }
    if(this.fileName){ 
        this.fileList.push({name:this.fileName});
    }
  },
  mounted() {

  },
  methods: {
      handlePreview(file) {
         this.fileData = file;
         this.uploadSubmit(file);
      },
      handleExceed(files, fileList) {
          this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      uploadSubmit:function(fileData){
         const formData = new FormData();
         formData.append('file', fileData.raw);
         !this.showList && this.$refs.upload.clearFiles();
         uploadFile(formData).then(result => {
             this.$emit("on-upload", result);
         });
     }
  }
}

</script>
<style>

</style>
